import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerData } from "@cinch-labs/customer-data-segment";
import styles from "./black-friday-banner.module.css";
export function BlackFridayBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = useCustomerData();
    const handleOnClick = ()=>{
        const data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "shop sale now"
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Black Friday sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.saveTag,
                children: "BLACK FRIDAY"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.text,
                children: [
                    "Save ",
                    /*#__PURE__*/ _jsx("b", {
                        children: "\xa31000"
                    }),
                    " off",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    " ",
                    "22 – 28 Nov. ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/policies/black-friday-sale",
                        children: "T&Cs apply"
                    })
                ]
            })
        ]
    });
}
export default BlackFridayBanner;
